import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { TagCreate, TagEntity, TagUpdate } from '@repo/types';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TagApiService extends BaseApi<TagEntity, TagCreate, TagUpdate> {
  constructor() {
    super('Tags', {
      get: '/AdminPanel/GetTags',
      post: '/AdminPanel/AddTag',
    });
  }
  getAllTags<T = TagEntity>() {
    let queryParams = `?Pagination.Page=1&Pagination.AmountOfListPerPage=999999&filters.type=0`;
    return http$
      .get<{ dataWithPagination: { data: T[] } }>(`${this.endpoint.get}${queryParams}`)
      .pipe(map((i) => i.dataWithPagination.data));
  }

  updateTag(model: TagUpdate) {
    console.log(model);
    return http$.patch<never>('/AdminPanel/EditTag', model);
  }

  deleteTag(id: number) {
    return http$.delete<never>('/AdminPanel/DeleteTag', { body: { id: id } });
  }
}
